import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Container, Row, Col } from "react-bootstrap";
import { FaFilePdf, FaFileWord, FaChevronRight, FaFileAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import "./CaseStudies.css";

const LEFT_COLUMN = [
  {
    icon: FaFilePdf,
    iconColor: "pdf",
    title: "Bandhaguda-DWS-Case Study",
    subtitle: "View case study",
    href: "/assets/files/6.pdf",
  },
  {
    icon: FaFilePdf,
    iconColor: "pdf",
    title: "Dalpatiguda-Milling Unit Case Study",
    subtitle: "View case study",
    href: "/assets/files/7.pdf",
  },
  {
    icon: FaFilePdf,
    iconColor: "pdf",
    title: "Kitchen Garden-Palkaguda",
    subtitle: "View case study",
    href: "/assets/files/8.pdf",
  },
  {
    icon: FaFilePdf,
    iconColor: "pdf",
    title: "Palkaguda-Case Study Mushroom",
    subtitle: "View case study",
    href: "/assets/files/9.pdf",
  },
  {
    icon: FaFilePdf,
    iconColor: "pdf",
    title: "Restoration of Dignity",
    subtitle: "View case study",
    href: "/assets/files/10.pdf",
  },
];

const RIGHT_COLUMN = [
  {
    icon: FaFilePdf,
    iconColor: "pdf",
    title: "Bandhaguda-DWS-Case Study",
    subtitle: "View case study",
    href: "/assets/files/6.pdf",
  },
  {
    icon: FaFilePdf,
    iconColor: "pdf",
    title: "Dalpatiguda-Milling Unit Case Study",
    subtitle: "View case study",
    href: "/assets/files/7.pdf",
  },
  {
    icon: FaFilePdf,
    iconColor: "pdf",
    title: "Kitchen Garden-Palkaguda",
    subtitle: "View case study",
    href: "/assets/files/8.pdf",
  },
  {
    icon: FaFilePdf,
    iconColor: "pdf",
    title: "Palkaguda-Case Study Mushroom",
    subtitle: "View case study",
    href: "/assets/files/9.pdf",
    external: true,
  },
  {
    icon: FaFileWord,
    iconColor: "word",
    title: "Disability Profile",
    subtitle: "View document",
    href: "/assets/files/10.pdf",
  },
];

const CaseStudies = () => {
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100, damping: 20 },
    },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const renderColumn = (items) => (
    <motion.ul
      className="cs-list"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      {items.map((item, index) => {
        const Icon = item.icon;
        return (
          <motion.li key={index} variants={itemVariants} className="cs-listItem">
            <a
              href={item.href}
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noopener noreferrer" : undefined}
              className="cs-card"
            >
              <span className={`cs-card__icon cs-card__icon--${item.iconColor}`}>
                <Icon />
              </span>
              <span className="cs-card__body">
                <span className="cs-card__title">{item.title}</span>
                <span className="cs-card__subtitle">{item.subtitle}</span>
              </span>
              <span className="cs-card__arrow">
                <FaChevronRight />
              </span>
            </a>
          </motion.li>
        );
      })}
    </motion.ul>
  );

  return (
    <>
      <Header />

      {/* ================= Hero (1521 x 482) ================= */}
      <section className="cs-page">
        <div className="cs-container">
          <div className="cs-hero">
            <div
              className="cs-hero__image"
              style={{ backgroundImage: "url(/assets/images/backgrounds/Case.jpg)" }}
            />
            <div className="cs-hero__overlay" />
            <div className="cs-hero__content">
              <motion.h2
                initial={{ opacity: 0, y: -30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="cs-hero__title"
              >
                Case Studies
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.3 }}
                className="cs-hero__text"
              >
                Explore Vikash's case studies for real-world examples of our
                impact, showcasing successful initiatives and transformative
                stories from the communities we serve.
              </motion.p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= Case Studies List ================= */}
      <Container className="cs-main">
        <Row className="justify-content-center g-4">
          <Col md={6}>{renderColumn(LEFT_COLUMN)}</Col>
          <Col md={6}>{renderColumn(RIGHT_COLUMN)}</Col>
        </Row>

        {/* ================= CTA ================= */}
        <motion.div
          className="cs-cta"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="cs-cta__content">
            <span className="cs-cta__icon">
              <FaFileAlt />
            </span>
            <div>
              <h3 className="cs-cta__title">Knowledge. Impact. Change.</h3>
              <span className="cs-cta__underline" />
              <p className="cs-cta__text">
                Our research drives evidence-based solutions that empower
                communities and create a sustainable future.
              </p>
            </div>
          </div>
          <div className="cs-cta__imageWrap">
            <img
              src="assets/images/sections/books-plant.jpg"
              alt="Books and a growing plant"
              className="cs-cta__image"
            />
          </div>
        </motion.div>
      </Container>

      <Footer />

      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text">Go Back Top</span>
      </a>
    </>
  );
};

export default CaseStudies;